module.exports = __webpack_public_path__ + "static/media/LP4.1889760b.svg";